export default "__VITE_ASSET__253354be__"